// const logConsoleRe = (action, param) => {
//   if (!window.localStorage.getItem("debug")) return
//   if (console.re) {
//     // console.re.log("-----------------------------------")
//     if (Array.isArray(param)) {
//       console.re[action](param[0], param[1])
//       window._LTracker.push({
//         param: param[0],
//         data: param[1],
//       })
//     } else {
//       console.re[action](param)
//       window._LTracker.push({
//         data: param,
//       })
//     }
//     // console.re.log("Current User", window.currentUser)
//     // console.re.log("-----------------------------------")
//   }
// }

const log = (action, param) => {
  if (!window.localStorage.getItem("debug")) return
  if (console) {
    if (Array.isArray(param)) {
      console[action](param[0], param[1])
      window._LTracker.push({
        param: param[0],
        data: param[1],
      })
    } else {
      console[action](param)
      window._LTracker.push({
        data: param,
      })
    }
  }
}

export default log
